import { useEffect, useRef, type ReactNode } from "react";

export function HomeSectionReveal({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      element.dataset.homeReveal = "shown";
      return;
    }

    let animationFrame: number | null = null;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        animationFrame = requestAnimationFrame(() => {
          element.dataset.homeReveal = "visible";
        });
        observer.disconnect();
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.04 },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div ref={ref} data-home-reveal="pending">
      {children}
    </div>
  );
}
